'use client';

import React, { HTMLAttributes, RefAttributes, useState } from 'react';

import parser from 'html-react-parser';
import { getTranslation } from '@/lib/utils';
import { parseOptions } from '@/utils/parseOptions';
import './styles.css';
import Slider from 'react-slick';
import { NewPageSubsection } from '@/types/TermPage';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import ChevronLeftIcon from '../Icons/ChevronLeft';
import ChevronRightIcon from '../Icons/ChevronRight';

interface ISatisfiedOwnersCarouselSectionProps
  extends HTMLAttributes<HTMLDivElement> {
  lang: Locale;
  sectionData: NewPageSubsection[];
}

export const SatisfiedOwnersCarouselSection: React.FC<
  ISatisfiedOwnersCarouselSectionProps
> = ({ sectionData, lang, ...rest }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const slider = React.useRef<Slider>(null);

  const settings = {
    dots: true,
    dotsClass: 'carousel-dots',
    infinite: true,
    speed: 1000,
    arrows: false,
    initialSlide: 0,
    slidesToShow: 1,
    beforeChange: (currentSlide: number, nextSlide: number) => {
      setCurrentPage(nextSlide);
    },
    slidesToScroll: 1,
  };

  const carouselItems = sectionData.map((item) => (
    <div
      key={item.id}
      className={`
      bg-white p-8 desktop:pl-[110px] w-[calc(100%-30px)] desktop:!w-full text-gray-900 relative flex flex-row
      after:border-r-[32px] after:border-b-[32px] after:border-transparent after:-bottom-[31px]
      after:border-r-white after:left-[110px] after:absolute
      ${String.raw`desktop:before:[content:'\201C']`} before:h-full before:absolute
      before:left-6 before:top-0 before:font-title before:text-[140px] before:text-gray-500
      before:content-[""]
    `}>
      <div className="w-full h-full flex flex-col">
        <div className="font-averta-italic text-subtitle leading-[1.45] text-start tablet:text-justify mb-6 overflow-hidden whitespace-normal">
          {parser(
            getTranslation(item.pageSectionTranslation, lang).description || '',
            parseOptions,
          )}
        </div>
        <strong className="font-text text-base font-semibold">
          {getTranslation(item.pageSectionTranslation, lang).title}
        </strong>
      </div>
    </div>
  ));

  return (
    <div className="w-[calc(100%-40px)] desktop:w-[calc(100%-80px)] xl:w-[calc(100%-160px)] relative">
      <button
        onClick={() => slider?.current?.slickPrev()}
        className="hidden lg:flex z-10 justify-center group items-center absolute -left-2 desktop:-left-6 -mt-12 bg-transparent top-1/2 desktop:-translate-y-1/2">
        <ChevronLeftIcon className="group-hover:opacity-20 transition stroke-white opacity-100 w-8 h-8 desktop:w-16 desktop:h-16" />
      </button>
      <Slider
        ref={slider}
        {...settings}
        className="tour-carousel single-carousel w-full">
        {carouselItems}
      </Slider>
      <button
        onClick={() => slider?.current?.slickNext()}
        className="hidden lg:flex z-10 justify-center group items-center absolute -right-2 desktop:-right-6 -mt-12 bg-transparent top-1/2 desktop:-translate-y-1/2">
        <ChevronRightIcon className="group-hover:opacity-20 transition stroke-white opacity-100 w-8 h-8 desktop:w-16 desktop:h-16" />
      </button>
    </div>
  );
};

export default SatisfiedOwnersCarouselSection;
